import OrderConfirm from './OrderConfirm';
import OrderList from './OrderList';
import OrderDetail from './OrderDetail';
import OrderRefund from './OrderRefund';

const ACTION = {
  ...OrderConfirm.ACTION,
  ...OrderList.ACTION,
  ...OrderDetail.ACTION,
  ...OrderRefund.ACTION,
};

const ACTION_TYPES = {
  ...OrderConfirm.ACTION_TYPES,
  ...OrderList.ACTION_TYPES,
  ...OrderDetail.ACTION_TYPES,
  ...OrderRefund.ACTION_TYPES,
};

const Order = {
  ACTION,
  ACTION_TYPES
}

export default Order;